import { render, staticRenderFns } from "./WorkplacesPie.vue?vue&type=template&id=0960eb62&"
import script from "./WorkplacesPie.vue?vue&type=script&lang=js&"
export * from "./WorkplacesPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports